<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a><span>Menus</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            Editar Menus
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <template #extra>
                    <a-button @click="isEditMode = true" v-if="!isEditMode"
                              style="color: white; background-color: blue">Editar Menus
                    </a-button>
                    <a-button @click="update" v-if="isEditMode" style="color: white; background-color: green">Salvar
                    </a-button>
                </template>
                <a-table
                    :columns="columns"
                    :data-source="dataSource"
                    class="components-table-demo-nested"
                    :rowKey="record => record.id"
                    :rowExpandable="record => record.childrens && record.childrens.length > 0"
                >

                    <template #bodyCell="{ column, record }">
                        <template v-if="isEditMode">
                            <div v-if="column.dataIndex === 'icon'" class="cell-icon-edit">
                                <span class="cell-icon">
                                    <component v-if="record.icon && antdIconsMap[record.icon]" :is="antdIconsMap[record.icon]" />
                                    <span v-else class="icon-placeholder">—</span>
                                </span>
                                <a-button type="link" size="small" @click="openIconModal(record)">Alterar</a-button>
                                <a-button type="link" size="small" @click="record.icon = null">Limpar</a-button>
                            </div>
                            <a-input v-else-if="column.dataIndex !== 'active'" v-model:value="record[column.dataIndex]" type="text"/>
                            <a-checkbox v-else v-model:checked="record[column.dataIndex]" :disabled="!isEditMode"/>
                        </template>
                        <template v-else>
                            <span v-if="column.dataIndex === 'icon'" class="cell-icon">
                                <component v-if="record.icon && antdIconsMap[record.icon]" :is="antdIconsMap[record.icon]" />
                                <span v-else>{{ record.icon || '—' }}</span>
                            </span>
                            <span v-else-if="column.dataIndex !== 'active'">{{ record[column.dataIndex] }}</span>
                            <a-checkbox v-else :checked="record[column.dataIndex]" :disabled="!isEditMode"/>
                        </template>
                    </template>

                    <template #expandedRowRender="{ record }">
                        <div class="child-table-container">
                            <table class="child-table">
                                <thead>
                                <tr>
                                    <th>Ordem</th>
                                    <th>Nome</th>
                                    <th>Objetivo</th>
                                    <th>Ícone</th>
                                    <th>Ativo</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="menu in record.childrens" :key="menu.id">
                                    <td>
                                        <template v-if="isEditMode">
                                            <a-input v-model:value="menu.order" type="text"/>
                                        </template>
                                        <template v-else>
                                            <span>{{ menu.order }}</span>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="isEditMode">
                                            <a-input v-model:value="menu.name" type="text"/>
                                        </template>
                                        <template v-else>
                                            <span>{{ menu.name }}</span>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="isEditMode">
                                            <a-input v-model:value="menu.objective" type="text"/>
                                        </template>
                                        <template v-else>
                                            <span>{{ menu.objective }}</span>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="isEditMode">
                                            <div class="cell-icon-edit">
                                                <span class="cell-icon">
                                                    <component v-if="menu.icon && antdIconsMap[menu.icon]" :is="antdIconsMap[menu.icon]" />
                                                    <span v-else class="icon-placeholder">—</span>
                                                </span>
                                                <a-button type="link" size="small" @click="openIconModal(menu)">Alterar</a-button>
                                                <a-button type="link" size="small" @click="menu.icon = null">Limpar</a-button>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="cell-icon">
                                                <component v-if="menu.icon && antdIconsMap[menu.icon]" :is="antdIconsMap[menu.icon]" />
                                                <span v-else>{{ menu.icon || '—' }}</span>
                                            </span>
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="isEditMode">
                                            <a-checkbox v-model:checked="menu.active"/>
                                        </template>
                                        <template v-else>
                                            <a-checkbox :checked="menu.active" disabled/>
                                        </template>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                </a-table>
            </a-card>
        </div>

        <!-- Modal de seleção de ícone -->
        <a-modal
            v-model:open="iconModalVisible"
            title="Selecionar ícone"
            width="720px"
            :footer="null"
            destroy-on-close
            @cancel="iconTarget = null"
        >
            <a-input-search
                v-model:value="iconSearchText"
                placeholder="Pesquisar pelo nome do ícone (ex: File, Home, User)..."
                allow-clear
                class="icon-search-input"
            />
            <div class="icon-grid-wrapper">
                <div class="icon-grid">
                    <div
                        v-for="name in filteredIconNames"
                        :key="name"
                        class="icon-card"
                        :class="{ 'icon-card-selected': iconTarget && iconTarget.icon === name }"
                        @click="selectIcon(name)"
                    >
                        <span class="icon-card-icon">
                            <component :is="antdIconsMap[name]" />
                        </span>
                        <span class="icon-card-name" :title="name">{{ name }}</span>
                    </div>
                </div>
                <div v-if="filteredIconNames.length === 0" class="icon-grid-empty">
                    Nenhum ícone encontrado para "{{ iconSearchText }}".
                </div>
            </div>
        </a-modal>
    </a-spin>

</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { FileOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import { antdIconsMap, antdIconNames } from '../../../../utils/antdIcons'
import { openNotification } from '../../../../utils/utilities'

const iconModalVisible = ref(false)
const iconSearchText = ref('')
const iconTarget = ref(null)

const filteredIconNames = computed(() => {
    const q = (iconSearchText.value || '').trim().toLowerCase()
    if (!q) return antdIconNames
    return antdIconNames.filter(name => name.toLowerCase().includes(q))
})

function openIconModal(record) {
    iconTarget.value = record
    iconSearchText.value = ''
    iconModalVisible.value = true
}

function selectIcon(iconName) {
    if (iconTarget.value) {
        iconTarget.value.icon = iconName
    }
    iconModalVisible.value = false
    iconTarget.value = null
}

const columns = ref([
    {
        title: 'Ordem',
        dataIndex: 'order',
        key: 'order',
        sorter: (a, b) => a.order - b.order,
        width: 100,
    },
    {
        title: 'Nome',
        dataIndex: 'name',
        key: 'name',
        width: 180,
        sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
        title: 'Objetivo',
        dataIndex: 'objective',
        key: 'objective',
        width: 200,
    },
    {
        title: 'Ícone',
        dataIndex: 'icon',
        key: 'icon',
        width: 220,
    },
    {
        title: 'Ativo',
        dataIndex: 'active',
        key: 'active',
        width: 100,
    },
])

const isEditMode = ref(false)

const dataSource = ref();
const spinning = ref(false);
const route = '/api/configurations/menus';

onMounted(async () => {
    await load();
});

const load = async () => {
    try {
        spinning.value = true
        const response = await window.axios.get(route);
        dataSource.value = response.data.data;
        spinning.value = false;
    } catch (error) {
        spinning.value = false;
    }
}

const update = async () => {
    try {
        spinning.value = true
        let response = await window.axios.put(route + '/lote', dataSource.value)
        spinning.value = false
        openNotification('success', response.data.message)
        await (new Promise(resolve => setTimeout(resolve, 500)));
        window.location.reload()
    } catch (error) {
        spinning.value = false
        openNotification('error', error.message)
    }
}
</script>

<style scoped>
.child-table-container {
    display: flex;
    justify-content: center; /* Centraliza horizontalmente */
    width: 100%;
}

.child-table {
    border-collapse: collapse;
    width: 60%; /* Define um tamanho para não ficar muito larga */
    max-width: 600px;
    border: 1px solid #ddd;
}

.child-table th, .child-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}

.cell-icon {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.cell-icon .anticon {
    font-size: 16px;
}
.cell-icon-edit {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}
.icon-placeholder {
    color: #999;
}

/* Modal de ícones */
.icon-search-input {
    margin-bottom: 16px;
}
.icon-grid-wrapper {
    max-height: 420px;
    overflow-y: auto;
    margin: 0 -8px;
}
.icon-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 8px;
    padding: 4px;
}
.icon-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 8px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
}
.icon-card:hover {
    border-color: #1890ff;
    background: #e6f7ff;
}
.icon-card-selected {
    border-color: #1890ff;
    background: #e6f7ff;
}
.icon-card-icon {
    font-size: 24px;
    margin-bottom: 6px;
    color: #333;
}
.icon-card-icon :deep(.anticon) {
    font-size: 24px;
}
.icon-card-name {
    font-size: 11px;
    color: #666;
    text-align: center;
    word-break: break-all;
    line-height: 1.2;
}
.icon-grid-empty {
    padding: 24px;
    text-align: center;
    color: #999;
}
</style>
